import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Button, Modal, Form } from 'react-bootstrap'
import InputText from '../../../components/commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'

class MassiveDownloadCreateModal extends PureComponent {
  createDownload (values) {
    new Promise((resolve, reject) => {
      this.props.actions.createMassiveDownload(this.props.documentIds.toString(), values.fileName, values.observations, resolve)
    }).then((result) => {
      this.props.actions.closeModal()
    })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal) {
      this.props.initialize()
    }
    return null
  }

  componentDidUpdate () {
    // getSnapshotBeforeUpdate() should be used with componentDidUpdate()
  }

  render () {
    const { t, actions: { closeModal }, showModal, handleSubmit } = this.props
    const tKey = 'DOCUMENT_SEARCH.MASSIVE_DOWNLOAD.'
    return (
      <Modal id='MassiveDownloadCreateModal' className="_nf" show={showModal} onHide={closeModal}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.createDownload.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE_MODAL`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='fieldsContainer'>
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}FILE_NAME`)}
                placeholder={t(`${tKey}FILE_NAME`)}
                id="fileName"
                name="fileName"
                maxLength={16}
              />
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}OBSERVATIONS`)}
                placeholder={t(`${tKey}OBSERVATIONS`)}
                componentClass="textarea"
                id="observations"
                name="observations"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='flexInLine al-C'>
              <Button id="btn_save" className="_Btn new" type="submit">{t('GLOBAL.BUTTONS.CREATE_DOWNLOAD')}</Button>
              <Button id="btn_no_modal" className="_Btn cancel" onClick={() => { closeModal() } }>{t('GLOBAL.BUTTONS.CANCEL')}</Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

const validate = (values, { t, reasonCombo, commentValidation }) => {
  const tKey = 'DOCUMENT_SEARCH.MASSIVE_DOWNLOAD.'
  const errors = {}
  if (!values.fileName) {
    errors.fileName = t(`${tKey}ERROR_REQUIRED`)
  }
  if (values.fileName && !values.fileName.match(/^[A-Za-z0-9]*$/)) {
    errors.fileName = t(`${tKey}ERROR_FORMAT`)
  }
  return errors
}

export default
reduxForm({
  form: 'massiveDownloadCreateModal',
  validate
})(MassiveDownloadCreateModal)
